import { Component , Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-jt-actions-modal',
    templateUrl: './app-action-button-modal.component.html',
    styleUrls: ['./app-action-button-modal.component.css'],
    standalone: false
})
export class AppJTActionButtonModalComponent  {
  @Input() hideDefaultAction? = false;
  @Output() bySave = new EventEmitter();
  @Output() byCancel = new EventEmitter();
  constructor() {
  }


  public Save() {
    this.bySave.emit();
  }

  public Cancel() {
    this.byCancel.emit();
  }



}
